import React from 'react';
import '../styles/Global.css';
import logo from '../assets/logo/consphic.svg';
import facebookIcon from '../assets/socialmedia/facebook-small.svg';
import youtubeIcon from '../assets/socialmedia/youtube-small.svg';
import xIcon from '../assets/socialmedia/X-small.svg';
import instagramIcon from '../assets/socialmedia/instagram-small.svg';
import linkedinIcon from '../assets/socialmedia/linkedIn-small.svg';

const socialLinks = [
    { icon: facebookIcon, label: 'Facebook', url: 'https://facebook.com/' },
    { icon: youtubeIcon, label: 'YouTube', url: 'https://youtube.com/' },
    { icon: xIcon, label: 'X', url: 'https://x.com/' },
    { icon: instagramIcon, label: 'Instagram', url: 'https://instagram.com/' },
    { icon: linkedinIcon, label: 'LinkedIn', url: 'https://linkedin.com/' }
];

const Footer: React.FC = () => (
    <footer className="page-footer">
        <div className="footer-flex-row">
            <div className="footer-logo">
                <a href="/">
                    <img src={logo} alt="Consphic Logo" className="logo-image" />
                </a>
            </div>
            <div className="footer-policy-links">
                <a href="/privacy-notice" className="footer-link">Privacy Notice</a>
                <a href="/cookie-policy" className="footer-link">Cookie Policy</a>
                <a href="/disclaimer" className="footer-link">Disclaimer</a>
                <a href="/security-policy" className="footer-link">Security Policy</a>
                <a href="/customize-cookies" className="footer-link">Customize Cookies</a>
            </div>
            <div className="footer-social-icons">
                {socialLinks.map(link => (
                    <a href={link.url} key={link.label} className="footer-social-link" target="_blank" rel="noopener noreferrer">
                        <img src={link.icon} alt={link.label} className="footer-social-icon" />
                    </a>
                ))}
            </div>
        </div>
        <hr className="footer-divider" />
        <div className="footer-copyright-row">
            <span className="footer-copyright">
                CONSPHIC all right reserved
            </span>
        </div>
    </footer>
);

export default Footer;